import { render, staticRenderFns } from "./ContentsHeader2.vue?vue&type=template&id=4d46aca7&scoped=true"
import script from "./ContentsHeader2.vue?vue&type=script&lang=js"
export * from "./ContentsHeader2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d46aca7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d46aca7')) {
      api.createRecord('4d46aca7', component.options)
    } else {
      api.reload('4d46aca7', component.options)
    }
    module.hot.accept("./ContentsHeader2.vue?vue&type=template&id=4d46aca7&scoped=true", function () {
      api.rerender('4d46aca7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/common/ContentsHeader2.vue"
export default component.exports